exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".trends-list-bullet[data-v-f535e9ce] {\n  height: 8px;\n  width: 8px;\n  border-radius: 50%;\n  margin-right: 8px;\n  display: inline-block;\n}\n", ""]);

// exports
